import { Component, Input } from '@angular/core';
import { TabsComponent } from '../tabs.component';

@Component({
    selector: 'qms-tab',
    templateUrl: './tab.component.html'
})
export class TabComponent {

    public active = false;

    @Input()
    public title: string;

    constructor(tabs: TabsComponent) {
        tabs.addTab(this);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/generic/tabs/tab/tab.component.ts